<template>
  <modal :title="$t('WallFile.add_wallfile')" @close-request="$emit('closeModal')" closable>
    <div class="modal-cont">
      <regular-input class="form-group" :value="wallFileName" @input="wallFileName = $event" :disabled="!isAdmin"
        :placeholder="$t('WallFile.enter_name')" />

        <div class="toggle-btn-container">
          <div class="df">
            <button class="btn btn-cnl btn-map" :class="{ 'orange': showPickMap }" @click="showMap('pick')">
              {{ $t('WallFile.show_pick_map') }}
            </button>
            <button class="btn btn-cnl btn-map" :class="{ 'orange': showDropMap }" @click="showMap('drop')">
              {{ $t('WallFile.show_drop_map') }}
            </button>
          </div>
          <div v-if="isAdmin" class="btn-div">
            <button class="btn btn-blk btn-cnl" @click="$emit('closeModal')">{{$t('Zones.cancel')}}</button>
            <button @click="saveWallFile()" class="btn btn-kne-orange">{{$t('Zones.save')}}</button>
          </div>
        </div>

      <!-- Pick Map Section -->
      <div class="map-container" v-if="showPickMap">
        <div class="map-div">
          <gmap-map id="pickMap" :zoom="8" :center="center"></gmap-map>
        </div>
        
        <div v-if="isAdmin" class="side-panel">
          <div class="map-controls-container">
            <button v-if="!isDrawingZone" class="btn btn-kne-orange" @click="startDrawingZone">
              {{ $t('WallFile.draw_new_pick_zone') }}
            </button>
          </div>
          <!-- Zone drawing controls -->
          <div class="zone-name-container" v-if="isDrawingZone">
            <h4>{{ editingZoneIndex === -1 ? $t('WallFile.new_zone') : $t('WallFile.update_zone') }}</h4>
            <regular-input class="zone-name-input" :value="newZoneName" @input="newZoneName = $event"
              placeholder="Enter zone name" />
            <div class="action-buttons">
              <button class="btn btn-kne-orange save-zone-btn" @click="saveCustomZone('pick')">Save</button>
              <button class="btn btn-cnl cancel-zone-btn" @click="cancelDrawing">Cancel</button>
            </div>
          </div>
          
          <!-- Custom zones list -->
          <div class="custom-zones-list" v-if="customPickZones.length > 0">
            <h4>{{ $t('WallFile.pick_zone') }}</h4>
            <div v-for="(zone, index) in customPickZones" :key="'pick-' + index" class="custom-zone-item">
              <span class="zone-name">{{ zone.name }}</span>
              <div class="zone-actions">
                <button class="btn btn-edit" @click="editCustomZone('pick', index)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="svg-icn">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                  </svg>
                </button>
                <button class="btn btn-del" @click="deleteCustomZone('pick', index)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="svg-icn">
                    <path fill-rule="evenodd"
                      d="M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"
                      clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Drop Map Section -->
      <div class="map-container" v-if="showDropMap">
        <div class="map-div">
          <gmap-map id="dropMap" :zoom="8" :center="center"></gmap-map>
        </div>
        
        <div class="side-panel" v-if="isAdmin">
          <div class="map-controls-container">
            <button v-if="!isDrawingZone && isAdmin" class="btn btn-kne-orange" @click="startDrawingZone">
              {{ $t('WallFile.draw_new_drop_zone') }}            
            </button>
          </div>
          <!-- Zone drawing controls -->
          <div class="zone-name-container" v-if="isDrawingZone">
            <h4>
              {{ editingZoneIndex === -1 ? $t('WallFile.new_zone') : $t('WallFile.update_zone') }}
            </h4>
            <regular-input class="zone-name-input" :value="newZoneName" @input="newZoneName = $event"
              placeholder="Enter zone name" />
            <div class="action-buttons" >
              <button class="btn btn-kne-orange save-zone-btn" @click="saveCustomZone('drop')">Save</button>
              <button class="btn btn-cnl cancel-zone-btn" @click="cancelDrawing">Cancel</button>
            </div>
          </div>
          
          <!-- Custom zones list -->
          <div class="custom-zones-list" v-if="customDropZones.length > 0">
            <h4>{{ $t('WallFile.drop_zone') }}</h4>
            <div v-for="(zone, index) in customDropZones" :key="'drop-' + index" class="custom-zone-item">
              <span class="zone-name">{{ zone.name }}</span>
              <div class="zone-actions">
                <button class="btn btn-edit" @click="editCustomZone('drop', index)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="svg-icn">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                  </svg>
                </button>
                <button class="btn btn-del" @click="deleteCustomZone('drop', index)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="svg-icn">
                    <path fill-rule="evenodd"
                      d="M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"
                      clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="btn-div">
        <button class="btn btn-blk btn-cnl" @click="$emit('closeModal')">{{$t('Zones.cancel')}}</button>
        <button @click="saveWallFile()" class="btn btn-kne-orange">{{$t('Zones.save')}}</button>
      </div> -->
    </div>
  </modal>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import Modal from '../../interface-components/Modal.vue'
import { db } from '../../../../firebase'
import RegularSelect from '../../basic-components/regularSelect.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import RegularDatalist from '../../basic-components/regularDatalistDriver.vue'
import { MultiSelect } from 'vue-search-select'
import * as turf from '@turf/turf'

export default {
  components: {
    Modal,
    RegularSelect,
    RegularInput,
    RegularDatalist,
    MultiSelect
  },
  data () {
    return {
      center: { lat: 45.5374842, lng: -73.6034393 },
      zones: [],
      zonesData: [],
      wallFileName: '',
      wallFileNames: [],
      pickZones: [],
      dropZones: [],
      pickPolygonObject: {},
      dropPolygonObject: {},
      pickPolygon: [],
      dropPolygon: [],
      showPickMap: false,
      showDropMap: false,
      zoneIds: {},
      // New data properties for custom zones
      customPickZones: [],
      customDropZones: [],
      isDrawingZone: false,
      newZoneName: '',
      currentDrawingMap: null,
      editingZoneIndex: -1,
      activeDrawingManager: null,
      activePolygon: null
    }
  },
  methods: {
  showMap (type) {
      if (this.isDrawingZone && this.activePolygon) {
        this.activePolygon.setMap(null)
        this.activePolygon = null
        this.isDrawingZone = false
        this.newZoneName = ''
        this.editingZoneIndex = -1
      }
      this.showPickMap = false
      this.showDropMap = false
      if (type === 'pick') {
        this.showPickMap = true
        this.currentDrawingMap = 'pick'
        setTimeout(() => this.renderMap('pickMap', this.pickPolygon, this.pickPolygonObject, this.handlePickPolygonChange), 100)
      } else {
        this.showDropMap = true
        this.currentDrawingMap = 'drop'
        setTimeout(() => this.renderMap('dropMap', this.dropPolygon, this.dropPolygonObject, this.handleDropPolygonChange), 100)
      }
    },

    checkZoneIntersections (type, coordinates, excludeIndex = -1) {
      const zones = type === 'pick' ? this.customPickZones : this.customDropZones

      for (let i = 0; i < zones.length; i++) {
        if (i === excludeIndex) continue

        const zoneCoords = zones[i].coordinates

        const newZonePolygon = this.mapPolygons(coordinates)
        const existingZonePolygon = this.mapPolygons(zoneCoords)

        // Check for intersection
        if (this.checkPolygonIntersection(newZonePolygon, existingZonePolygon)) {
          return {
            intersects: true,
            zoneName: zones[i].name
          }
        }
      }
      return { intersects: false }
    },

    saveCustomZone (type) {
      if (!this.newZoneName) {
        alert('Please enter a zone name')
        return
      }

      if (!this.activePolygon) {
        alert('Please draw a zone first')
        return
      }
      const coordinates = this.extractPolygonArray(this.activePolygon)

      const intersectionCheck = this.checkZoneIntersections(
        type,
        coordinates,
        this.editingZoneIndex
      )

      if (intersectionCheck.intersects) {
        alert(`Your zone intersects with the existing zone "${intersectionCheck.zoneName}". Please redraw to avoid intersections.`)
        return
      }

      const newZone = {
        name: this.newZoneName,
        coordinates: coordinates,
        color: this.getRandomColor()
      }

      if (this.editingZoneIndex >= 0) {
        if (type === 'pick') {
          this.customPickZones[this.editingZoneIndex] = newZone
        } else {
          this.customDropZones[this.editingZoneIndex] = newZone
        }
      } else {
        if (type === 'pick') {
          this.customPickZones.push(newZone)
        } else {
          this.customDropZones.push(newZone)
        }
      }

      // Reset state
      this.isDrawingZone = false
      this.newZoneName = ''
      this.editingZoneIndex = -1
      this.activePolygon.setMap(null)
      this.activePolygon = null

      this.showMap(type)
    },
    renderMap (mapId, polygonData, polygonObject, polygonChangeHandler) {
      const polygonCenter = this.polygonCenter
      const getRandomColor = this.getRandomColor
      if (!this.google) {
        console.error('Google object is not defined yet.', this.google)
        setTimeout(() => this.renderMap(mapId, polygonData, polygonObject, polygonChangeHandler), 100)
        return
      }

      let mapOptions = {
        zoom: 7,
        mapTypeControl: false,
        streetViewControl: false,
        scaleControl: false,
        fullscreenControl: true,
        center: new this.google.maps.LatLng(45.5374842, -73.6034393)
      }

      if (!document.getElementById(mapId)) return

      let map = new this.google.maps.Map(document.getElementById(mapId), mapOptions)
      if (!map) return

      // Store map reference for later use
      this[mapId + 'Reference'] = map

      // Initialize the main polygon for wall file boundaries
      const drawingManagerOptions = {
        drawingMode: null, // Start without drawing mode
        drawingControl: true,
        drawingControlOptions: {
          position: this.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [this.google.maps.drawing.OverlayType.POLYGON]
        },
        polygonOptions: {
          fillColor: 'black',
          fillOpacity: 0.70,
          strokeWeight: 4,
          strokeColor: 'black',
          clickable: false,
          editable: true,
          zIndex: 1
        }
      }

      const drawingManager = new this.google.maps.drawing.DrawingManager(drawingManagerOptions)
      drawingManager.setMap(map)

      // Store drawing manager reference for later use
      this[mapId + 'DrawingManager'] = drawingManager

      const google = this.google
      const color = 'black'
      let arry = []
      polygonData.forEach(function (elem, idx) {
        if (elem[0] != null && elem[1] != null) {
          arry.push(new google.maps.LatLng(elem[1], elem[0]))
        }
      })

      const polygonOptions = {
        paths: arry,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 4,
        fillColor: color,
        editable: true,
        draggable: true,
        fillOpacity: 0.70
      }
      polygonObject = new google.maps.Polygon(polygonOptions)
      polygonObject.setMap(map)

      // Render existing zones
      this.zonesData.forEach(function (element, index) {
        try {
          element.coords = element.coords || element.coordinates
        } catch (e) {
          return
        }
        let arry = []
        if (!Array.isArray(element.coords)) {
          return
        }
        element.coords.forEach(function (elem, idx) {
          if (elem[0] != null && elem[1] != null) {
            arry.push(new google.maps.LatLng(elem[1], elem[0]))
          }
        })
        if (arry != null) {
          element.coordinates = arry
        }
        const color = element.color ? element.color : getRandomColor()
        element.color = color
        const polygonOptions = {
          paths: element.coordinates,
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: color,
          fillOpacity: 0.60
        }
        let polygonObj2 = new google.maps.Polygon(polygonOptions)
        polygonObj2.setMap(map)
        const polyCenter = polygonCenter(element.coords)
        const markerOptions = {
          position: polyCenter,
          label: { text: element.zoneName, color: 'black', fontSize: '18px', fontWeight: '400' },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
          }
        }
        let markerObj2 = new google.maps.Marker(markerOptions)
        markerObj2.setMap(map)
      })

      // Render custom zones
      const customZones = mapId === 'pickMap' ? this.customPickZones : this.customDropZones
      customZones.forEach((customZone, index) => {
        let arry = []
        customZone.coordinates.forEach(coord => {
          arry.push(new google.maps.LatLng(coord[1], coord[0]))
        })

        const color = customZone.color || this.getRandomColor()
        const polygonOptions = {
          paths: arry,
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: color,
          fillOpacity: 0.60
        }

        let polygonObj = new google.maps.Polygon(polygonOptions)
        polygonObj.setMap(map)

        // Add zone name as a marker
        const coords = customZone.coordinates.map(coord => [coord[0], coord[1]])
        const polyCenter = this.polygonCenter(coords)

        const markerOptions = {
          position: { lat: polyCenter.lat, lng: polyCenter.lng },
          label: { text: customZone.name, color: 'black', fontSize: '18px', fontWeight: '400' },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
          }
        }

        let markerObj = new google.maps.Marker(markerOptions)
        markerObj.setMap(map)
      })

      if (polygonData.length) {
        this.addPolygonListeners(polygonObject, polygonChangeHandler)
      }

      this.google.maps.event.addListener(drawingManager, 'polygoncomplete', (polygon) => {
        if (this.isDrawingZone) {
          // This is for a custom zone
          this.activePolygon = polygon
        } else {
          // This is for the main wallfile boundary
          polygonObject.setMap(null)
          polygonObject = polygon
          polygonChangeHandler(polygon)
          this.addPolygonListeners(polygon, polygonChangeHandler)
        }

        // Turn off drawing mode
        drawingManager.setDrawingMode(null)
      })
    },
    addPolygonListeners (polygon, handler) {
      this.google.maps.event.addListener(polygon.getPath(), 'set_at', () => handler(polygon))
      this.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => handler(polygon))
      this.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => handler(polygon))
    },
    polygonCenter (poly) {
      let lats = poly.map((point) => point[1])
      let lngs = poly.map((point) => point[0])

      let lowx = Math.min(...lats)
      let highx = Math.max(...lats)
      let lowy = Math.min(...lngs)
      let highy = Math.max(...lngs)

      let centerX = lowx + (highx - lowx) / 2
      let centerY = lowy + (highy - lowy) / 2

      return { lat: centerX, lng: centerY }
    },
    getRandomColor () {
      let letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    extractPolygonArray (polygon) {
      let polygonArr = []
      for (let i = 0; i < polygon.getPath().getLength(); i++) {
        let point = [
          polygon.getPath().getAt(i).lng(),
          polygon.getPath().getAt(i).lat()
        ]
        polygonArr.push(point)
      }
      return polygonArr
    },
    handlePickPolygonChange (polygon) {
      this.pickPolygon = this.extractPolygonArray(polygon)
    },
    handleDropPolygonChange (polygon) {
      this.dropPolygon = this.extractPolygonArray(polygon)
    },
    checkPolygonIntersection (polygon1, polygon2) {
      const feature1 = turf.polygon(polygon1, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const feature2 = turf.polygon(polygon2, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const intersects = turf.booleanIntersects(feature1, feature2)
      return intersects
    },
    mapPolygons (polygon) {
      let arr = [[...polygon]]
      arr[0].push(arr[0][0])
      return arr
    },
    isZoneIntersecting (newZoneCoordinates, zones) {
      let intersecting = []
      zones.forEach((zone) => {
        if (this.zone && this.zone.id === zone.id) {
          return
        }
        if (this.checkPolygonIntersection(this.mapPolygons(newZoneCoordinates), this.mapPolygons(zone.coords))) {
          intersecting.push(zone)
        }
      })
      return intersecting
    },
    getWallFiles () {
      db.ref('database/wallfiles/transporter').child(this.companyUID).child('wallfile').once('value', (snapshot) => {
        if (snapshot.exists()) {
          this.wallFileNames = Object.entries(snapshot.val()).map(([id, data]) => (data.name))
        } else {
          this.wallFileNames = []
        }
      })
    },
    // New methods for custom zones management
    startDrawingZone () {
      this.isDrawingZone = true
      this.newZoneName = ''
      this.editingZoneIndex = -1

      // Enable drawing mode on the current map
      const mapId = this.currentDrawingMap === 'pick' ? 'pickMap' : 'dropMap'
      const drawingManager = this[mapId + 'DrawingManager']

      if (drawingManager) {
        drawingManager.setDrawingMode(this.google.maps.drawing.OverlayType.POLYGON)
        this.activeDrawingManager = drawingManager
      }
    },
    cancelDrawing () {
      this.isDrawingZone = false
      this.newZoneName = ''
      this.editingZoneIndex = -1

      // Remove any active polygon
      if (this.activePolygon) {
        this.activePolygon.setMap(null)
        this.activePolygon = null
      }

      // Turn off drawing mode
      if (this.activeDrawingManager) {
        this.activeDrawingManager.setDrawingMode(null)
      }
    },
    editCustomZone (type, index) {
      const zoneToEdit = type === 'pick' ? this.customPickZones[index] : this.customDropZones[index]

      // Set editing state
      this.isDrawingZone = true
      this.newZoneName = zoneToEdit.name
      this.editingZoneIndex = index

      // Enable drawing mode and create a polygon based on the zone's coordinates
      const mapId = type === 'pick' ? 'pickMap' : 'dropMap'
      const map = this[mapId + 'Reference']

      if (map) {
        let arry = []
        zoneToEdit.coordinates.forEach(coord => {
          arry.push(new this.google.maps.LatLng(coord[1], coord[0]))
        })

        const polygonOptions = {
          paths: arry,
          strokeColor: zoneToEdit.color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: zoneToEdit.color,
          fillOpacity: 0.60,
          editable: true
        }

        // Create the polygon and set it as active
        this.activePolygon = new this.google.maps.Polygon(polygonOptions)
        this.activePolygon.setMap(map)
      }
    },
    deleteCustomZone (type, index) {
      if (confirm('Are you sure you want to delete this zone?')) {
        if (type === 'pick') {
          this.customPickZones.splice(index, 1)
        } else {
          this.customDropZones.splice(index, 1)
        }

        // Refresh the map
        this.showMap(type)
      }
    },
    saveWallFile () {
      if (!this.wallFileName) {
        alert('Please enter name to create the wallfile')
        return
      }

      if (this.wallFileNames.includes(this.wallFileName)) {
        if (!this.$props.wallFile || this.$props.wallFile.name !== this.wallFileName) {
          alert('Wall file name already exists. Please enter a new name')
          return
        }
      }

      const pickPolygon = this.pickPolygon
      const dropPolygon = this.dropPolygon

      if (this.$props.wallFile) {
        db.ref('database/wallfiles/transporter').child(this.companyUID).child('wallfile').child(this.$props.wallFile.id).set(
          {
            name: this.wallFileName,
            pickPolygon,
            dropPolygon,
            customPickZones: this.customPickZones,
            customDropZones: this.customDropZones
          }
        ).then(() => {
          console.log('Wallfile added')
          this.wallFileName = ''
          this.pickZones = []
          this.dropZones = []
          this.customPickZones = []
          this.customDropZones = []
          this.$emit('closeModal')
        }).catch(function (error) {
          alert('Error adding wall file')
          console.error(error)
        })
      } else {
        db.ref('database/wallfiles/transporter').child(this.companyUID).child('wallfile').push().set(
          {
            name: this.wallFileName,
            pickPolygon,
            dropPolygon,
            customPickZones: this.customPickZones,
            customDropZones: this.customDropZones
          }
        ).then(() => {
          console.log('Wallfile added')
          this.wallFileName = ''
          this.pickZones = []
          this.dropZones = []
          this.customPickZones = []
          this.customDropZones = []
          this.$emit('closeModal')
        }).catch(function (error) {
          alert('Error adding wall file')
          console.error(error)
        })
      }
    },
    handlePickZoneSelect: function (list) {
      this.pickZones = list
    },
    handleDropZoneSelect: function (list) {
      this.dropZones = list
    },
    loadWallFileData (wallfile) {
      console.log({wallfile})
      this.wallFileName = wallfile.name
      this.pickPolygon = wallfile.pickPolygon || []
      this.dropPolygon = wallfile.dropPolygon || []
      this.pickZones = wallfile.pickZones ? wallfile.pickZones.map(zoneId => {
        return this.zones.find(z => z.value === zoneId) || null
      }).filter(Boolean) : []
      this.dropZones = wallfile.dropZones ? wallfile.dropZones.map(zoneId => {
        return this.zones.find(z => z.value === zoneId) || null
      }).filter(Boolean) : []

      // Load custom zones
      this.customPickZones = wallfile.customPickZones || []
      this.customDropZones = wallfile.customDropZones || []
    }
  },
  mounted () {
    this.getWallFiles()
    if (this.$props.wallFile) {
      this.loadWallFileData(this.$props.wallFile)
    }
  },
  computed: {
    google: gmapApi,
    companyUID () {
      return this.$store.state.authorization.company
    }
  },
  props: {
    wallFile: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>

<style scoped>
.df {
  display: flex;
  flex-wrap: nowrap;
}
.btn-map {
  margin-bottom: 15px;
  margin-left: 10px;
}
.map-container {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
}
.map-div {
  flex: 3;
  height: 60vh;
  position: relative;
}
.map-div > * {
  width: 100%;
  height: 100%;
}
.side-panel {
  flex: 1;
  margin-left: 15px;
  max-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.map-controls-container button{
 width: 100%;
}
.zone-name-container {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.zone-name-input {
  margin-bottom: 10px;
}
.action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
.custom-zones-list {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
}
.custom-zone-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
.zone-name {
  word-break: break-word;
  max-width: 120px;
}
.zone-actions {
  display: flex;
  gap: 5px;
}
.btn-edit, .btn-del {
  padding: 8px;
  font-size: 18px;
  display: inline-flex;   /* Ensures the button content is properly aligned */
  align-items: center;    /* Centers the SVG inside the button */
  justify-content: center;
  border-radius: 4px;
}

.btn-edit svg, .btn-del svg {
  width: 24px;
  height: 24px;
  fill: currentColor;  /* Ensures the color is inherited from the button */
}

.btn-edit {
  border: 1px solid #4ade80;
  color: #4ade80;
  background-color: transparent;
  cursor: pointer;
}

.btn-del {
  border: 1px solid #f00;
  color: #f00;
  background-color: transparent;
  cursor: pointer;
}
.save-zone-btn, .cancel-zone-btn {
  flex: 1;
}
.orange {
  background-color: orange;
}
.btn-div {
  gap: 10px;
  margin-left: auto;
  bottom: 0%;
  right: 0%;
  /* margin-bottom: 30px; */
}
.toggle-btn-container {
  display: flex;
  justify-content: space-between;
}
.btn-div>.btn {
  /* margin-top: 4px; */
}

.btn-blk {
  color: white;
  background-color: black;
}

.modal-cont {
  width: 95%;
  margin: 0 auto;
  margin-top: 20px;
}

.zone-select {
  margin-bottom: 15px;
}

@media (max-width: 768px) {
  .map-container {
    flex-direction: column;
  }
  .side-panel {
    max-width: 100%;
    margin-left: 0;
    margin-top: 15px;
  }
  .map-div {
    height: 50vh;
  }
  .zone-name {
    max-width: 180px;
  }
}
</style>
